var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"calendarContainer"},[_c('iframe',{ref:"calendar",attrs:{"src":this.calendarSrc,"frameborder":"0","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }